import { createContext } from 'react';

export interface TaskDashboardContextValue {
  removeTask: (taskId: string) => void;
}

export const TaskDashboardContext = createContext<TaskDashboardContextValue | null>(null);
